import { Card } from '@/components/ui/card';
import { t, getLocale } from '@/i18n';
import { ReportHeader } from './ReportHeader';
import { ReportComment } from './ReportComment';

const dateLabel = (iso) => new Date(iso).toLocaleDateString(getLocale(), { weekday: 'long', day: 'numeric', month: 'numeric' });

const Fact = ({ label, value }) => (
  <div>
    <div className="text-[11px] text-muted-foreground">{label}</div>
    <div className="text-lg font-bold tabular-nums">{value}</div>
  </div>
);

const TruckList = ({ title, items, empty }) => (
  <div className="space-y-1">
    <div className="text-xs font-semibold">{title} ({items.length})</div>
    {items.length === 0 ? (
      <div className="text-xs text-muted-foreground">{empty}</div>
    ) : (
      <ul className="text-xs divide-y">
        {items.map((i, idx) => (
          <li key={idx} className="py-1.5 flex gap-2">
            <span className="tabular-nums text-muted-foreground w-10 shrink-0">{i.planned}</span>
            <span className="min-w-0">
              <span className="font-medium">{i.plate}</span> · {i.carrier}
              <span className="block text-muted-foreground">{i.orderId}</span>
            </span>
          </li>
        ))}
      </ul>
    )}
  </div>
);

// Preview of the daily summary sent to planners and dispatch at 16:00.
export const DailySummary = ({ report }) => (
  <Card className="p-4 space-y-4">
    <ReportHeader title={t('reports.daily.title')} schedule={t('reports.daily.schedule')} period={dateLabel(report.date)} />
    <ReportComment kind="daily" report={report} />
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      <Fact label={t('reports.daily.planned')} value={report.planned} />
      <Fact label={t('reports.daily.loaded')} value={report.loaded} />
      <Fact label={t('stats.kpi.noShows')} value={report.noShows} />
      <Fact label={t('stats.kpi.informed')} value={`${report.informedPct} %`} />
    </div>
    <div className="text-xs text-muted-foreground">
      {t('reports.daily.urgencies')
        .replace('{total}', report.urgencies)
        .replace('{auto}', report.autoResolved)
        .replace('{planner}', report.urgencies - report.autoResolved)}
    </div>
    <TruckList title={t('reports.daily.missing')} items={report.missing} empty={t('reports.daily.none')} />
    <TruckList title={t('reports.daily.open')} items={report.open} empty={t('reports.daily.none')} />
  </Card>
);
